module.exports = __webpack_public_path__ + "static/media/4XL.35fb18e2.jpg";